import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import MagneticButton from './MagneticButton';

export default function CTA() {
  return (
    <section
      id="contact"
      className="relative bg-background text-foreground py-24 md:py-32 px-8 md:px-28"
    >
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl border border-border bg-card overflow-hidden"
        >
          {/* soft radial glow */}
          <div
            aria-hidden
            className="absolute inset-0 opacity-60 pointer-events-none"
            style={{
              background:
                'radial-gradient(60% 80% at 50% 0%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 70%)',
            }}
          />
          <div className="relative px-8 md:px-16 py-16 md:py-24 text-center">
            <h2 className="text-4xl md:text-6xl font-medium tracking-[-1.5px] leading-[1.05] max-w-3xl mx-auto">
              Ready to make your social media{' '}
              <span className="font-serif italic font-normal">
                actually work?
              </span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
              Book a free 20-minute strategy call. We’ll audit your current
              channels and show you exactly where AI can move the needle.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <MagneticButton href="mailto:contact@sprynai.com" strength={16}>
                <motion.span
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  transition={{ type: 'spring', stiffness: 320, damping: 20 }}
                  className="inline-flex items-center gap-2 bg-foreground text-background rounded-full px-8 py-3.5 text-base font-medium shadow-[0_10px_40px_-10px_rgba(255,255,255,0.4)]"
                >
                  Get Started for Free
                  <ArrowRight className="h-4 w-4" />
                </motion.span>
              </MagneticButton>
              <a
                href="#services"
                className="inline-flex items-center gap-2 rounded-full border border-border px-8 py-3.5 text-base font-medium text-foreground hover:bg-white/[0.04] transition-colors"
              >
                Explore services
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
